<template>
  <MDBRow>
    <MDBCol cols="12" lg="6" xl="4" class="mb-4" v-for="(training, i) in trainings" :key="i"
      :class="`${training.show ? '' : 'd-none'}`">
      <Card :data="training" :linkText="$t('global.buttons.discover')" />
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import Card from "@/components/General/Card/index.vue";
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { computed } from "vue";
import { useItemsConditions } from '@/composables/useItemsConditions'
import { useTenantConfig } from "@/composables/useTenantConfig";
import { setOnlineTrainingLink } from "@/composables/useProfileFieldCheck";
const { getContext } = useItemsConditions()
const context = computed(() => getContext())
import { useI18n } from "vue-i18n";
const { t } = useI18n() // Import the translation function from i18n
const { tenantConfig } = useTenantConfig();
const { onlineTrainingLink } = setOnlineTrainingLink(tenantConfig);

const trainings = computed(() => [
  {
    name: t("trainings.index.online.title"),
    link: { name: onlineTrainingLink() },
    description: t("trainings.index.online.desc"),
    image: require("@/assets/img/online-trainings-poster.png"),
    show: context.value.canSeeOnlineTraining,
  },
  {
    name: t("trainings.index.lectures.title"),
    link: { name: "bridgestoneSchulungen" },
    description: t("trainings.index.lectures.desc"),
    image: require("@/assets/img/schulungen-poster.png"),
    show: context.value.canSeeBTraining,
  },
  {
    name: t("trainings.index.external.title"),
    link: { name: "externeTraining" },
    description: t("trainings.index.external.desc"),
    image: require("@/assets/img/externe-schulungen-poster.png"),
    show: context.value.canSeeExternalTraining,
  },
]);
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
</style>
